export default __webpack_public_path__ + "static/media/camera.4bb8dd7c.svg";